// extracted by mini-css-extract-plugin
export var dateDay = "style-module--dateDay--pLKZA";
export var dateDetails = "style-module--dateDetails--bAK43";
export var globalTitle = "style-module--globalTitle--r0Nix";
export var header = "style-module--header--RsbVF";
export var hours = "style-module--hours--9GmOy";
export var hoursDesc = "style-module--hoursDesc--1GRnr";
export var line = "style-module--line--C7q-8";
export var signUp = "style-module--signUp--Rmvgd";
export var singleHoursWrapper = "style-module--singleHoursWrapper--f-QhF";
export var splash = "style-module--splash--WPOyB";
export var tabButtonsWrapper = "style-module--tabButtonsWrapper--xSubg";
export var tabs = "style-module--tabs--FZ5R1";
export var timetableTabs = "style-module--timetableTabs--bQZEx";
export var titleDesc = "style-module--titleDesc--KrhJD";